<template>
  <div id="app">
    <router-view />
    <div
      v-show="is_show_footer"
      id="footer"
      class="footer"
    >
      <router-link
        to="/"
        class="footer_item"
        :class="show_icon_type === 'index' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon footer_icon_home" />
        <p class="footer_info">
          {{ $t('home.index') }}
        </p>
      </router-link>
			
      <router-link
        to="/faxian"
        class="footer_item"
        :class="show_icon_type === 'faxian' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon footer_icon_faxian" />
        <p class="footer_info">
          {{ $t('utils.faxian') }}
        </p>
      </router-link>
      <router-link
        to="/invest"
        class="footer_item"
        :class="show_icon_type === 'invest' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon footer_icon_invest" />
        <p class="footer_info">
          {{ $t('home.invest') }}
        </p>
      </router-link>
      <!-- <router-link to="/lun" class="footer_item" :class="show_icon_type === 'lun' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_lun" />
				<p class="footer_info">
					{{$t('utils.luntan')}}
				</p>
			</router-link> -->
      <router-link
        to="/user"
        class="footer_item"
        :class="show_icon_type === 'user' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon footer_icon_user" />
        <p class="footer_info">
          {{ $t('home.my') }}
        </p>
      </router-link>
    </div>
    <div
      v-if="show_loading_wrap"
      class="loading_wrap"
    >
      <img
        :src="require('./views/img/index/loading.gif'+'')"
        alt=""
      >
    </div>
  </div>
</template>

<script>
	import Fetch from "./utils/fetch";

	export default {
		name: 'App',
		data() {
			return {
				show_icon_type: 'index',
				is_show_footer: true,
				show_loading_wrap: true,
				lang: 'en_us'
			}
		},
		updated() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
		mounted() {
			// 检查是否有保存的登录令牌，如果有则恢复登录状态
			const token = localStorage.getItem('token');
			if (token) {
				this.$store.commit('setLogin', { token: token });
			}
			this.start();
		},
		methods: {
			onSwipeLeft(even, start, end) {
				if (end['X'] - start['X'] > 60) {
					this.$router.go(-1);
				}
			},
			footer: function(type = 'index', show_footer = true) {
				this.show_icon_type = type;
				this.is_show_footer = show_footer;
			},
			start() {
				// //首次启动，判断浏览器语言，自动切换成浏览器语言
				// var lang1 = navigator.language;
				// if (localStorage.getItem("lang") == null && this.langs[lang1] != 'undefined') {
				// 	this.$i18n.locale = this.langs[lang1];
				// 	localStorage.setItem("lang", this.langs[lang1]);
				// }
				var reload = false;
				if (localStorage.getItem("reload")) {
					reload = true;
				}
				Fetch("/index/webconfig", {
					reload: reload
				}, "", false).then((r) => {
					this.setLang(r.data.language);
					window.document.title = r.data.webname;
					localStorage.setItem("logo", r.data.logo);
					localStorage.setItem("logo2", r.data.logo2);
					localStorage.setItem('currency', "");
					localStorage.setItem('precision', r.data.precision);
					localStorage.setItem('currency_symbol_basic', 'EUR');
					localStorage.setItem('precision_basic', 0);
					localStorage.setItem("language_logo", r.data.language_logo);
				});
			},
			setLang(lang) {
				if (!localStorage.getItem("lang")) {
					localStorage.setItem("lang", lang);
					this.$i18n.locale = lang;
					localStorage.setItem("reload", true);
					location.reload();
				} else {
					this.show_loading_wrap = false;
				}
			}
		}
	}
</script>
<style lang="less">
	// @import "./assets/font/font.css";
	.kefu {
		width: 80px;
		height: 80px;
		position: fixed;
		z-index: 10;
		right: 13px;
		bottom: 50px;
		transition: all 1s;
		opacity: 1;
		transform: translateX(0);
		z-index: 80;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.kefu.kefu_hide {
		transform: translateX(70%);
		opacity: 0.5;
	}

	html,
	body {
		width: 100%;
		height: 100%;
		
		// overflow-y: scroll;
	}

	html::-webkit-scrollbar,
	body::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}
:root {
            --bg-primary: #0a0a0f;
            --bg-secondary: #12121a;
            --bg-card: #1a1a28;
            --accent: #e5097b;
            --accent-blue: #4a6cf7;
            --text-primary: #ffffff;
            --text-secondary: #a0a0b0;
            --text-muted: #6a6a7a;
            --border: rgba(255, 255, 255, 0.06);
            --radius-lg: 14px;
            --radius-md: 10px;
            --radius-sm: 6px;
            --safe-bottom: env(safe-area-inset-bottom, 16px);
			--bg-primary: #000000;
			           
			--bg-primary: #000000;
			--bg-secondary: #0a0a0d;
			--bg-card: #141418;
			--accent: #e50914;
			--accent-blue: #3b82f6;
			--accent-gold: #fbbf24;
			--accent-silver: #c0c0c0;
			--accent-bronze: #cd7f32;
			--text-primary: #f5f5f5;
			--text-secondary: #a1a1aa;
			--text-muted: #6b6b75;
			--border: rgba(255, 255, 255, 0.08);
			--radius-xl: 20px;
			--radius-lg: 16px;
			--radius-md: 12px;
			--radius-sm: 8px;
			--safe-bottom: env(safe-area-inset-bottom, 16px);
			--shadow-card: 0 2px 12px rgba(0, 0, 0, 0.5);
			--shadow-elevated: 0 8px 30px rgba(0, 0, 0, 0.6);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
        }

        body {
            font-family: 'Inter', 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
            background-color: #000;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            min-height: 100vh;
            -webkit-font-smoothing: antialiased;
        }

        #app {
            width: 100%;
            max-width: 430px;
            min-height: 100vh;
            background-color: var(--bg-primary);
            //color: var(--text-primary);
            position: relative;
            overflow-x: hidden;
            // padding-bottom: calc(72px + var(--safe-bottom));
            box-shadow: 0 0 60px rgba(0, 0, 0, 0.6);
        }

	.red_top_bg{
		background-color:unset !important;
	}
	#app .footer {
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		-webkit-box-flex: 0;
		-ms-flex: 0 0 48px;
		flex: 0 0 48px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: distribute;
		justify-content: space-around;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		background: rgba(8, 8, 12, 0.96);
		    border-top: 1px solid #e7edf8;
		    box-shadow: 0 -6px 20px rgba(23, 64, 128, .08);
		width: 100%;
		bottom: 0;
		height: 60px;
		z-index: 4;
	}

	#app .footer .footer_item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		cursor: pointer;
		color: #6b6b75;
		width: 25%;
	}

	#app .footer .footer_item .footer_icon {
		display: inline-block;
		width: 26px;
		height: 26px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		margin-bottom: 6px;
	}

	#app .footer .footer_item .footer_icon.footer_icon_home {
		background-image: url(./views/img/home/home_cur.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_faxian {
		background-image: url(./views/img/home/faxian_cur.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_invest {
		background-image: url(./views/img/home/invest_cur.png);
	}

	
// #app .footer .footer_item .footer_icon.footer_icon_lun {
// 		background-image: url(./views/img/home/lun.jpg);
// 	}
	#app .footer .footer_item .footer_icon.footer_icon_user {
		background-image: url(./views/img/home/user_cur.png);
	}

	#app .footer .footer_item .footer_info {
		font-size: 12px;
	}

	#app .footer .footer_item.footer_item_active {
		color: #fff;
		
	}

	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_home {
		background-image: url(./views/img/home/home_cur.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_faxian {
		background-image: url(./views/img/home/faxian_cur.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_invest {
		background-image: url(./views/img/home/invest_cur.png);
	}

	
	// #app .footer .footer_item.footer_item_active .footer_icon.footer_icon_lun {
	// 	background-image: url(./views/img/home/lun.jpg);
	// }
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_user {
		background-image: url(./views/img/home/user_cur.png);
	}

	.loading_wrap {
		width: 100%;
		height: 100%;
		position: absolute;
		background: #FFFFFF;
		z-index: 9999;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 150px;
			height: 150px;
		}
	}

	.red_top_bg {
		width: 100%;
		max-width: 750px;
		height: 44px;
		margin: 0 auto;
		background-size: 100% 100%;
		overflow: hidden;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
	}

	.big_tit {
		position: absolute;
		height: 44px;
		font-size: 16px;
		color: #fff;
		text-align: center;
		line-height: 44px;
		top: 0;
		left: 80px;
	}

	.back_left {
		width: 30px;
		height: 30px;
		background: url(./views/img/common/back_b.png) no-repeat center center;
		background-size: auto 100%;
		margin: 7px 0 0 8px;
	}

	.top_right {
		position: absolute;
		font-size: 13px;
		line-height: 18px;
		color: #FFFFFF;
		top: 16px;
		right: 14px;
	}

	.basic_btn {
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		width: 80%;
		margin-left: 10%;
		background-size: 100% 100%;
		border-radius: 23px;
		color: #FFFFFF;
		background: #e50914;
		text-align: center;
	}

	.basic_btn.no_touch {
		color: rgba(255, 255, 255, 0.5);
	}

	.flex_center {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.eye_bi {
		width: 21px;
		height: 25px;
		background: url(./views/img/user/eye2.png) no-repeat center center;
		background-size: 100% auto;

		&.eye {
			background: url(./views/img/user/eye1.png) no-repeat center center;
			background-size: 100% auto;
		}
	}

	.block_div {
		// border-radius: 10px;
		width: 92%;
		margin-left: 4%;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
		background: #FFFFFF;
		border-radius: 5px;
	}

	.pending {
		border-bottom: 4px solid #ECECEC !important;
	}

	.color_red {
		color: #FF0000;
	}

	.color_green {
		color: #3CB371;
	}

	.color_blue {
		color: #3775f4;
	}

	.currency {
		font-size: 12px;
		margin-left: 3px;
		font-weight: initial;
	}
	.toast {
	            position: fixed;
	            top: 50%;
	            left: 50%;
	            transform: translate(-50%, -50%) scale(0.85);
	            background: rgba(28, 28, 38, 0.96);
	            color: #fff;
	            padding: 14px 28px;
	            border-radius: 28px;
	            font-size: 14px;
	            font-weight: 600;
	            z-index: 999;
	            pointer-events: none;
	            opacity: 0;
	            transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
	        }
	        .toast.show {
	            opacity: 1;
	            transform: translate(-50%, -50%) scale(1);
	        }
</style>
